import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { FracturedHalo } from './FracturedHalo';
export const About: React.FC = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const haloRotate = useTransform(scrollYProgress, [0, 1], [0, 180]);
  const haloScale = useTransform(scrollYProgress, [0, 0.5, 1], [0.5, 1.2, 0.8]);
  const haloOpacity = useTransform(scrollYProgress, [0, 0.3, 0.7, 1], [0, 1, 1, 0]);
  const textX = useTransform(scrollYProgress, [0, 0.5], [100, 0]);
  const textOpacity = useTransform(scrollYProgress, [0, 0.3, 0.7], [0, 1, 1]);
  return <section id="about" ref={sectionRef} className="relative py-24 md:py-32 bg-black overflow-hidden" data-id="element-12">
      <div className="container mx-auto px-4 md:px-6" data-id="element-13">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-14">
          <motion.div className="relative flex justify-center" style={{
          rotate: haloRotate,
          scale: haloScale,
          opacity: haloOpacity
        }} data-id="element-15">
            <motion.div animate={{
            scale: [1, 1.1, 1]
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-16">
              <FracturedHalo size={400} segments={7} opacity={0.7} data-id="element-17" />
            </motion.div>
          </motion.div>
          <motion.div style={{
          x: textX,
          opacity: textOpacity
        }} data-id="element-18">
            <motion.h2 className="text-3xl md:text-4xl font-heading font-light tracking-wider mb-6 text-neon-blue glow-text" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} viewport={{
            once: true,
            amount: 0.5
          }} data-id="element-19">
              About DEPLOID
            </motion.h2>
            <div className="space-y-6 text-neon-blue/80 text-justify" data-id="element-20">
              <motion.p className="leading-relaxed" initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6,
              delay: 0.1
            }} viewport={{
              once: true,
              amount: 0.5
            }} data-id="element-21">
                DEPLOID is a next-generation AI consultancy that bridges the gap
                between cutting-edge artificial intelligence and practical
                business solutions. We transform complex AI technologies into
                deployed, actionable systems that drive tangible results.
              </motion.p>
              <motion.p className="leading-relaxed" initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6,
              delay: 0.2
            }} viewport={{
              once: true,
              amount: 0.5
            }} data-id="element-22">
                Founded by industry veterans with over 30 years of combined
                experience in the SaaS and digital transformation space, Deploid
                brings deep technical expertise and real-world operational
                understanding to the next generation of AI-driven automation.
                Our team has led hundred's of complex implementations, built
                scalable cloud architectures, and solved high-impact business
                problems for global brands. Deploid exists to turn that
                experience into powerful, industry-ready AI agents that help
                organisations automate, optimise, and grow with confidence.
              </motion.p>
              <motion.div className="pt-4 grid grid-cols-1 gap-4 md:gap-6" initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6,
              delay: 0.3
            }} viewport={{
              once: true,
              amount: 0.5
            }} data-id="element-23">
                <motion.div className="border border-neon-blue/10 p-4 rounded-sm bg-cosmic-blue/20" whileHover={{
                scale: 1.05,
                borderColor: 'rgba(234, 246, 255, 0.3)',
                boxShadow: '0 0 20px rgba(234, 246, 255, 0.2)'
              }} transition={{
                duration: 0.3
              }} data-id="element-24">
                  <h3 className="text-neon-blue font-medium mb-2" data-id="element-25">30+ Years</h3>
                  <p className="text-sm text-neon-blue/70" data-id="element-26">
                    Cloud, Data, & SaaS Delivery Expertise
                  </p>
                </motion.div>
                <motion.div className="border border-neon-blue/10 p-4 rounded-sm bg-cosmic-blue/20" whileHover={{
                scale: 1.05,
                borderColor: 'rgba(234, 246, 255, 0.3)',
                boxShadow: '0 0 20px rgba(234, 246, 255, 0.2)'
              }} transition={{
                duration: 0.3
              }} data-id="element-27">
                  <h3 className="text-neon-blue font-medium mb-2" data-id="element-28">100+</h3>
                  <p className="text-sm text-neon-blue/70" data-id="element-29">
                    AI/Automation Use Cases Designed by Our Team
                  </p>
                </motion.div>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};